<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-strikethrough`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M33.58 6.59C31.263 4.409 27.85 3.3 23.434 3.3c-4.481 0-8.109 1.325-10.489 3.817-1.894 1.97-2.945 4.447-3.007 7.074-.053 2.24.508 4.224 1.619 5.81l7.983-.002c-1.106-.386-1.915-.777-2.674-1.26-1.556-.95-2.408-2.553-2.364-4.413.099-4.164 3.833-7.072 8.96-7.072 3.153 0 5.657 1.018 7.225 2.957.788.896 1.167 1.7 1.48 3.121l.03.128c.116.479.214.568.49.518l3.97-.72.064-.019c.221-.097.28-.478.133-1.004-.7-2.51-1.532-3.976-3.036-5.415l-.236-.23zM4 26a1 1 0 001 1h23.33c1.262.417 2.038.828 2.89 1.426 1.48 1.03 2.184 2.696 2.132 4.93-.11 4.628-4.058 7.523-10.127 7.523-3.546 0-6.317-.93-8.034-2.72-1.148-1.169-1.718-2.349-2.117-4.364l-.054-.248c-.134-.56-.292-.671-.904-.581l-.27.046-3.131.59c-.746.15-.792.298-.573 1.264l.085.365c.424 1.775.842 2.804 1.607 4.031 2.348 3.712 6.942 5.722 13.075 5.722 9.169 0 14.911-4.544 15.084-11.868.051-2.169-.487-4.198-1.522-5.833L36.284 27 43 27a1 1 0 001-1v-2a1 1 0 00-1-1H5a1 1 0 00-1 1v2z"/></svg>
</template>
<script>

export default {
  name: 'IconStrikethrough',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
